import { getDOMElement } from 'src/utils/DOM';
import { API_URL } from 'src/config';

export const verificationTokenInput = getDOMElement("input[name='__RequestVerificationToken']") as HTMLInputElement;

let csrfPromise: Promise<string> | null = null;

export const getCsrfToken = async (): Promise<string> => {
  if (csrfPromise) return csrfPromise;

  csrfPromise = (async () => {
    const response = await fetch(`${API_URL}/Csrf/GetCsrfToken`, {
      credentials: 'include',
      headers: { 'Cache-Control': 'no-cache' },
    });

    if (!response.ok) {
      csrfPromise = null;
      throw new Error(`GetCsrfToken failed: ${response.statusText}`);
    }

    const data = await response.json();
    const csrfToken = data.token;

    csrfPromise = null;
    if (csrfToken === null) {
      throw new Error('CSRF token is null');
    }
    return csrfToken;
  })();

  return csrfPromise;
};

export const setVerificationToken = (): Promise<void> =>
  getCsrfToken().then((response) => {
    verificationTokenInput.value = response;
  });
